import { UserIcon, UsersIcon, BarChartIcon } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { PlanId } from "./term-pricing";

/** Fallback when trialDurationDays is not yet loaded from the backend. */
export const DEFAULT_TRIAL_DURATION_DAYS = 14;

export const SALES_CONTACT_URL = "https://www.tenderapp.nl/contact";

export type PricingTier = {
  id: PlanId;
  name: string;
  icon: LucideIcon;
  subtitleKey: string;
  descriptionKey: string;
  featureKeys: string[];
};

export const PRICING_TIERS: PricingTier[] = [
  {
    id: "start",
    name: "Start",
    icon: UserIcon,
    subtitleKey: "Personal tender intelligence",
    descriptionKey: "Full insight into current opportunities",
    featureKeys: [
      "Current tenders from 15+ sources",
      "Enriched tender insights by data team",
      "Smart notifications",
      "AI chat documents",
      "Tender management",
      "Notes & tasks",
      "For 1 user",
      "SSO & MFA",
      "Data export",
    ],
  },
  {
    id: "grow",
    name: "Grow",
    icon: UsersIcon,
    subtitleKey: "Tender intelligence for teams",
    descriptionKey: "For teams that want to achieve success together",
    featureKeys: [
      "All Start features, plus",
      "Access to all tenders since 2017",
      "Smart insights at advisor and authority level",
      "Bid agenda",
      "Personal and shared views",
      "Microsoft Teams and Slack integration",
      "Add users at any time",
      "User profiles",
    ],
  },
  {
    id: "scale",
    name: "Scale",
    icon: BarChartIcon,
    subtitleKey: "Strategic tender intelligence",
    descriptionKey:
      "For organisations that want to gain control over future opportunities",
    featureKeys: [
      "All Grow features, plus",
      "Add your own opportunities",
      "More than 3,000 sources unlocked via TenderApp Horizon",
      "Contract timeline",
      "AI tender comparison",
      "AI bid/no-bid advice (coming soon)",
      "Contract expiry & forecast",
      "CRM integrations",
    ],
  },
];
